import { LucideIcon } from 'lucide-react';
import { MouseEvent } from 'react';

interface ToolbarButtonProps {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  icon: LucideIcon;
  label: string;
  disabled?: boolean;
  title?: string;
  variant?: 'default' | 'danger';
}

export function ToolbarButton({
  onClick,
  icon: Icon,
  label,
  disabled = false,
  title,
  variant = 'default',
}: ToolbarButtonProps) {
  const colorClass = variant === 'danger'
    ? 'text-red-600 hover:bg-red-50'
    : 'text-primary-500 hover:bg-gray-100';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center gap-2 px-3 py-2 ${colorClass} rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-w-0`}
      title={title || label || undefined}
    >
      <Icon className="w-4 h-4 flex-shrink-0" />
      {label && <span className="text-sm font-medium truncate">{label}</span>}
    </button>
  );
}
